import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ImageApi from "../../Api/imageApi";  
import { setMessage } from "./message";

export const uploadImage = createAsyncThunk(
  'image/uploadImage',
  async (formData, thunkAPI) => {
    try {
      const response = await ImageApi.uploadImage(formData);
      console.log("res:",response) 
      const message=(response.message)
    thunkAPI.dispatch(setMessage(message))
    return response.imageUrl; 
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      thunkAPI.dispatch(setMessage(message))
      return thunkAPI.rejectWithValue(message)    }
  }
);

export const updateImage = createAsyncThunk(
  'image/updateImage',
  async (formData, thunkAPI) => {
    try {
      
      const response = await ImageApi.updateImage(formData);
      console.log("API Response:", response);

      thunkAPI.dispatch(setMessage(response.message));
      return response.imageUrl;
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const imageSlice = createSlice({
  name: 'image',
  initialState: { imageUrl: '',  error: null,success:false },
  extraReducers: (builder) => {
    builder
    
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.imageUrl = action.payload;
        state.success=true;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.error = action.payload;
        state.success=false;
      })
      .addCase(updateImage.fulfilled, (state, action) => {
        state.imageUrl = action.payload;
        state.success=true;
      })
      .addCase(updateImage.rejected, (state, action) => {
        state.error = action.payload;
        state.success=false;
      });

  },
});

export default imageSlice.reducer;